<div class="appraisals-tasks-container">

  <div class="list-header">
    <div class="header-title">
      <h3>
        <i class="fa fa-tasks" aria-hidden="true" style="color: #0f766e; font-size: 18px; line-height: 1; margin-right: 8px;"></i>
        <span translate>APPRAISAL_TASKS</span>
      </h3>
      <span class="record-count">{{ totalItems }} {{ 'APPRAISAL_TASKS' | translate }}</span>
    </div>
  </div>

  <div *ngIf="canManageTasks" class="filters-section">
    <div class="row">
      <div class="col-md-3">
        <div class="form-group">
          <label translate>APPRAISAL_ACTION_POINT</label>
          <input
            type="text"
            class="form-control"
            [(ngModel)]="taskTitleFilter"
            (ngModelChange)="onFilterChange()"
            [placeholder]="'SEARCH' | translate"
          />
        </div>
      </div>
      <div class="col-md-3">
        <div class="form-group">
          <label translate>EMPLOYEE_NAME</label>
          <input
            type="text"
            class="form-control"
            [(ngModel)]="employeeNameFilter"
            (ngModelChange)="onFilterChange()"
            [placeholder]="'SEARCH' | translate"
          />
        </div>
      </div>
      <div class="col-md-2">
        <div class="form-group">
          <label translate>APPRAISAL</label>
          <input
            type="text"
            class="form-control"
            [(ngModel)]="appraisalTitleFilter"
            (ngModelChange)="onFilterChange()"
            [placeholder]="'SEARCH' | translate"
          />
        </div>
      </div>
      <div class="col-md-2">
        <div class="form-group">
          <label translate>STATUS</label>
          <select
            class="form-control"
            [(ngModel)]="statusFilter"
            (ngModelChange)="onFilterChange()"
          >
            <option *ngFor="let status of statusOptions" [ngValue]="status.value">
              {{ status.label }}
            </option>
          </select>
        </div>
      </div>
      <div class="col-md-2">
        <div class="form-group filter-actions">
          <label>&nbsp;</label>
          <button class="btn btn-outline-secondary clear-filters-btn" (click)="clearFilters()">
            <i class="fa fa-filter" aria-hidden="true"></i>
            <span translate>CLEAR_FILTERS</span>
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="table-view">
    <p-menu
      #rowActionMenu
      [popup]="true"
      [model]="rowActionItems"
      appendTo="body"
      styleClass="task-row-menu-overlay"
    ></p-menu>

    <p-table
      [value]="tasks"
      [rows]="pageSize"
      [totalRecords]="totalItems"
      [paginator]="true"
      [pageLinks]="3"
      [rowsPerPageOptions]="[5, 10, 20, 50]"
      [lazy]="true"
      [loading]="isLoading"
      [(selection)]="selectedTasks"
      (onPage)="onPageChange($event)"
      (onSort)="onSort($event)"
      [showCurrentPageReport]="true"
      currentPageReportTemplate="{{ 'SUMMARY_TOTALRECORDS' | translate }}: {{ totalItems }}"
      styleClass="p-datatable-striped"
      [tableStyle]="{ 'table-layout': 'fixed', width: '100%' }"
    >
      <ng-template pTemplate="header">
        <tr>
          <th pSortableColumn="Title" class="action-point-column">
            {{ 'APPRAISAL_ACTION_POINT' | translate }}
            <p-sortIcon field="Title"></p-sortIcon>
          </th>
          <th pSortableColumn="Description" class="description-column">
            {{ 'DESCRIPTION' | translate }}
            <p-sortIcon field="Description"></p-sortIcon>
          </th>
          <th pSortableColumn="EmployeeName" class="employee-column">
            {{ 'EMPLOYEE_NAME' | translate }}
            <p-sortIcon field="EmployeeName"></p-sortIcon>
          </th>
          <th pSortableColumn="AppraisalTitle" class="appraisal-column">
            {{ 'APPRAISAL' | translate }}
            <p-sortIcon field="AppraisalTitle"></p-sortIcon>
          </th>
          <th pSortableColumn="Status" class="status-column">
            {{ 'STATUS' | translate }}
            <p-sortIcon field="Status"></p-sortIcon>
          </th>
          <th pSortableColumn="DueDate" class="due-date-column">
            {{ 'DUE_DATE' | translate }}
            <p-sortIcon field="DueDate"></p-sortIcon>
          </th>
          <th class="actions-column">
            {{ 'ACTIONS' | translate }}
          </th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-task>
        <tr [ngClass]="{ 'overdue-row': isTaskOverdue(task) }">
          <td class="action-point-column">
            <div class="task-description">
              <strong class="truncate-line" [attr.title]="task.Title || null">{{ task.Title }}</strong>
              <small
                *ngIf="task.QuestionText"
                class="context-line truncate-line"
                [attr.title]="task.QuestionText"
              >
                {{ 'QUESTION' | translate }}: {{ task.QuestionText }}
              </small>
            </div>
          </td>
          <td class="description-column">
            <div
              class="task-description-preview"
              [class.task-description-preview-truncated]="hasTruncatedDescription(task.Description)"
              [attr.title]="task.Description || null"
            >
              {{ getDescriptionPreview(task.Description) }}
            </div>
          </td>
          <td class="employee-column">
            <div class="employee-info">
              <strong class="truncate-line" [attr.title]="task.EmployeeName || null">{{ task.EmployeeName || '—' }}</strong>
              <small
                *ngIf="task.AssignedToName"
                class="truncate-line"
                [attr.title]="task.CreatedByName || null"
              >
                {{ 'ASSIGNED_BY' | translate }}: {{ task.CreatedByName || '—' }}
              </small>
            </div>
          </td>
          <td class="appraisal-column">
            <div class="task-description">
              <strong class="truncate-line" [attr.title]="task.AppraisalTitle || null">{{ task.AppraisalTitle || '—' }}</strong>
              <small
                *ngIf="task.QuestionText"
                class="truncate-line"
                [attr.title]="getTaskContext(task) || null"
              >{{ getTaskContext(task) }}</small>
            </div>
          </td>
          <td class="status-column">
            <span
              class="badge"
              [ngClass]="getStatusClass(task.Status)"
              [attr.title]="getStatusText(task.Status) | translate"
            >
              {{ getStatusText(task.Status) | translate }}
            </span>
          </td>
          <td class="due-date-column">
            <div class="due-date" [ngClass]="{ 'text-danger': isTaskOverdue(task) }">
              {{ task.DueDate ? (task.DueDate | utcDate : 'dd-MM-yyyy') : '—' }}
              <i
                *ngIf="isTaskOverdue(task)"
                class="fa fa-exclamation-triangle text-danger"
                aria-hidden="true"
              ></i>
            </div>
          </td>
          <td class="actions-column">
            <div class="action-buttons">
              <button
                type="button"
                class="btn btn-sm btn-default action-menu-trigger"
                (click)="openActionMenu(rowActionMenu, task, $event)"
                [disabled]="isTaskActionPending(task.Id) || isDeletingSelectedTasks"
                [title]="'ACTIONS' | translate"
                [attr.aria-label]="'ACTIONS' | translate"
                aria-haspopup="true"
              >
                <i
                  [class]="isTaskActionPending(task.Id) ? 'fa fa-spinner fa-spin' : 'pi pi-bars'"
                  aria-hidden="true"></i>
              </button>
            </div>
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="7" class="text-center">
            <div class="empty-state">
              <i class="fa fa-tasks" aria-hidden="true"></i>
              <p class="empty-state-title" translate>
                APPRAISAL_EMPTY_TASKS_TITLE
              </p>
              <p class="empty-state-body" translate>
                APPRAISAL_EMPTY_TASKS_BODY
              </p>
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>

  <p-dialog
    [(visible)]="showTaskDetailDialog"
    [modal]="true"
    [closable]="true"
    [dismissableMask]="true"
    [style]="{ width: '640px', maxWidth: '95vw' }"
    styleClass="appraisal-task-detail-dialog"
    (onHide)="closeTaskDialog()"
    [header]="'APPRAISAL_ACTION_POINT' | translate"
  >
    <div *ngIf="isLoadingTaskDetail" class="task-detail-loading">
      <i class="fa fa-spinner fa-spin" aria-hidden="true"></i>
    </div>

    <div *ngIf="!isLoadingTaskDetail && selectedTaskDetail" class="task-detail-content">
      <div class="task-detail-header">
        <div>
          <h4>{{ selectedTaskDetail.Title }}</h4>
          <p>{{ selectedTaskDetail.AppraisalMeetingTitle || '—' }}</p>
        </div>
        <span class="badge" [ngClass]="getStatusClass(selectedTaskDetail.Status)">
          {{ getStatusText(selectedTaskDetail.Status) | translate }}
        </span>
      </div>

      <div class="task-detail-grid">
        <div class="detail-card">
          <span class="detail-label">{{ 'QUESTION' | translate }}</span>
          <span class="detail-value">{{ selectedTaskDetail.QuestionText || '—' }}</span>
        </div>
        <div class="detail-card">
          <span class="detail-label">{{ 'EMPLOYEE_NAME' | translate }}</span>
          <span class="detail-value">{{ selectedTaskDetail.EmployeeName || '—' }}</span>
        </div>
        <div class="detail-card">
          <span class="detail-label">{{ 'ASSIGN' | translate }}</span>
          <span class="detail-value">{{ selectedTaskDetail.AssignedToName || '—' }}</span>
        </div>
        <div class="detail-card">
          <span class="detail-label">{{ 'ASSIGNED_BY' | translate }}</span>
          <span class="detail-value">{{ selectedTaskDetail.CreatedByName || '—' }}</span>
        </div>
        <div class="detail-card">
          <span class="detail-label">{{ 'DUE_DATE' | translate }}</span>
          <span class="detail-value">
            {{ selectedTaskDetail.DueDate ? (selectedTaskDetail.DueDate | utcDate : 'dd-MM-yyyy') : '—' }}
          </span>
        </div>
        <div class="detail-card">
          <span class="detail-label">{{ 'COMPLETED_DATE' | translate }}</span>
          <span class="detail-value">
            {{ selectedTaskDetail.CompletedOn ? (selectedTaskDetail.CompletedOn | utcDate : 'dd-MM-yyyy HH:mm') : '—' }}
          </span>
        </div>
      </div>

      <div class="detail-card description-card">
        <span class="detail-label">{{ 'DESCRIPTION' | translate }}</span>
        <div class="detail-value multiline">
          {{ selectedTaskDetail.Description || '—' }}
        </div>
      </div>

      <div class="task-detail-actions">
        <button
          *ngIf="selectedTaskDetail && selectedTaskContext && canEditTask(selectedTaskContext)"
          type="button"
          class="btn btn-default"
          [disabled]="isTaskActionPending(selectedTaskDetail.Id) || isDeletingSelectedTasks"
          (click)="openEditTask(selectedTaskContext)"
        >
          {{ 'EDIT' | translate }}
        </button>
        <button type="button" class="btn btn-outline-primary" (click)="openLinkedAppraisal()">
          {{ 'VIEW_APPRAISAL' | translate }}
        </button>
        <button
          *ngIf="selectedTaskContext && canCompleteTask(selectedTaskContext)"
          type="button"
          class="btn btn-success"
          [disabled]="isTaskActionPending(selectedTaskDetail.Id) || isDeletingSelectedTasks"
          (click)="completeTask(selectedTaskContext)"
        >
          <i
            *ngIf="isTaskCompleting(selectedTaskDetail.Id)"
            class="fa fa-spinner fa-spin"
            aria-hidden="true"></i>
          {{ 'COMPLETE' | translate }}
        </button>
        <button
          *ngIf="selectedTaskContext && canDeleteTask(selectedTaskContext)"
          type="button"
          class="btn btn-danger"
          [disabled]="isTaskActionPending(selectedTaskDetail.Id) || isDeletingSelectedTasks"
          (click)="deleteTask(selectedTaskContext)"
        >
          <i
            *ngIf="isTaskDeleting(selectedTaskDetail.Id)"
            class="fa fa-spinner fa-spin"
            aria-hidden="true"></i>
          {{ 'DELETE' | translate }}
        </button>
      </div>
    </div>
  </p-dialog>

  <p-dialog
    [(visible)]="showTaskEditDialog"
    [modal]="true"
    [closable]="true"
    [dismissableMask]="true"
    [style]="{ width: '620px', maxWidth: '95vw' }"
    styleClass="appraisal-task-edit-dialog"
    (onHide)="closeTaskEditDialog()"
    [header]="'APPRAISAL_ACTION_POINT' | translate"
  >
    <div *ngIf="isLoadingTaskEdit" class="task-detail-loading">
      <i class="fa fa-spinner fa-spin" aria-hidden="true"></i>
    </div>

    <div *ngIf="!isLoadingTaskEdit && selectedTaskEdit" class="task-edit-content">
      <div class="detail-card">
        <span class="detail-label">{{ 'QUESTION' | translate }}</span>
        <span class="detail-value">{{ selectedTaskEdit.QuestionText || '—' }}</span>
      </div>

      <div class="detail-card">
        <span class="detail-label">{{ 'APPRAISAL' | translate }}</span>
        <span class="detail-value">{{ selectedTaskEdit.AppraisalMeetingTitle || '—' }}</span>
      </div>

      <div class="row">
        <div class="col-md-6">
          <label class="control-label">{{ 'TITLE' | translate }} *</label>
          <input
            type="text"
            class="form-control"
            [(ngModel)]="editTaskForm.Title"
            [placeholder]="'APPRAISAL_ACTION_POINT' | translate"
          />
        </div>
        <div class="col-md-6">
          <label class="control-label">{{ 'ASSIGN' | translate }}</label>
          <select class="form-control" [(ngModel)]="editTaskForm.AssignedToUserId">
            <option *ngFor="let option of taskAssignees" [ngValue]="option.id">
              {{ option.name }}
            </option>
          </select>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <label class="control-label">{{ 'DESCRIPTION' | translate }}</label>
          <textarea
            class="form-control"
            rows="3"
            [(ngModel)]="editTaskForm.Description"
            [placeholder]="'DESCRIPTION' | translate"
          ></textarea>
        </div>
      </div>

      <div class="row">
        <div class="col-md-6">
          <label class="control-label">{{ 'DUE_DATE' | translate }}</label>
          <input
            type="date"
            class="form-control"
            [min]="minTaskDueDate"
            [(ngModel)]="editTaskForm.DueDate"
          />
        </div>
      </div>

      <div class="task-detail-actions">
        <button
          type="button"
          class="btn btn-outline-secondary"
          [disabled]="isSavingTaskEdit"
          (click)="closeTaskEditDialog()">
          {{ 'CLOSE' | translate }}
        </button>
        <button
          type="button"
          class="btn btn-primary"
          [disabled]="isSavingTaskEdit || !editTaskForm.Title?.trim()"
          (click)="saveTaskEdit()"
        >
          <i *ngIf="isSavingTaskEdit" class="fa fa-spinner fa-spin" aria-hidden="true"></i>
          {{ 'SAVE' | translate }}
        </button>
      </div>
    </div>
  </p-dialog>
</div>

<p-confirmDialog [style]="{ width: '450px' }"></p-confirmDialog>
